import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  BrowserRouter,
  Navigate,
  Route,
  Router,
  Routes,
  useLocation,
} from "react-router-dom";
import ActivityLog from "./pages/activityLog/ActivityLog";
import BetHistory from "./pages/betHistory/BetHistory";
import CasinoResult from "./pages/casinoResults/CasinoResults";
import Footer from "./includes/footer";
import ProfitLossReport from "./pages/profitLossReport/ProfitLossReport";
import UnSetteledBet from "./pages/unSetteledBet/UnSetteledBet";
import store, { saveState } from "./redux/store";
import { useState } from "react";

import PrivateOutletM from "./layout/PrivateOutlet";
import AccountStatementM from "./pages/accountStatement/AccountStatementM";
import PublicOutletM from "./layout/PublicOutletM";
import MainLogin from "./layout/MainLogin";
import ChangeButtonValue from "./pages/changeButtonValue";
import ChangePassword from "./pages/ChangePassword";
import SuperOver from "./pages/casino/SuperOver";
import Race20 from "./pages/casino/Race20";
import FiveCricket from "./pages/casino/FiveCricket";
import AndarBahar2 from "./pages/casino/AndarBahar2";
import DragonTiger2 from "./pages/casino/DragonTiger2";
import Baccarat2 from "./pages/casino/Baccarat2";
import Baccarat from "./pages/casino/Baccarat";
import Lucky7A from "./pages/casino/Lucky7A";
import Lucky7B from "./pages/casino/Lucky7B";
import AmarAkhbarAnthoany from "./pages/casino/AmarAkhbarAnthoany";
import TeenpattiOneDay from "./pages/casino/TeenpattiOneDay";
import { QueryClient, QueryClientProvider } from "react-query";
import DragonTiger from "./pages/casino/DragonTiger";
import InitialRule from "./components/InitialRule";
import SecurityAuth from "./pages/securityAuth/SecurityAuth";
import Otp from "./layout/Otp";
import { Toaster } from "react-hot-toast";
import ResponsibleGaming from "./pages/ResponsibleGaming";
import TermsAndCondition from "./pages/TermsAndCondition";
import Home from "./pages/home";
import CricketGame from "./pages/game/cricket/CricketGames";
import Header from "./includes/header";
import SoccerGame from "./pages/game/soccer/SoccerGame";
import TennisGame from "./pages/game/tennis/TennisGame";
import BallByBall from "./pages/casino/BallByBall";
import Card3Judgement from "./pages/casino/Card3Judgement";

import CasinoWar from "./pages/casino/CasinoWar";
import DragonTigerLion from "./pages/casino/DragonTigerLion";
import TeenPattiOpen from "./pages/casino/TeenPattiOpen";
import TeenPatti from "./pages/casino/TeenPatti";
import Card32A from "./pages/casino/Card32A";
import TeenPattiTest from "./pages/casino/TeenPattiTest";
import WorliMatka from "./pages/casino/WorliMatka";
import BTable from "./pages/casino/BTable";
import Poker1Day from "./pages/casino/Poker1Day";
import Poker20 from "./pages/casino/Poker20";
import AndarBahar from "./pages/casino/AndarBahar";
import Card32B from "./pages/casino/Card32B";
import DragonTigerOneDay from "./pages/casino/DragonTigerOneDay";
import CasinoMeter from "./pages/casino/CasinoMeter";
import Poker6Player from "./pages/casino/Poker6Player";
import CasinoQueen from "./pages/casino/CasinoQueen";
import CricketMatch20 from "./pages/casino/CricketMatch20";
import CasinoComingSoon from "./pages/casino/CasinoComingSoon";
import CasinoList from "./pages/casino/CasinoList";
import Roulet from "./pages/casino/components/casinoGroup/Roulet";
import SportsPage from "./pages/home/SportsPage";
import InternationalCasino from "./pages/casino/InternationalCasino";
import InternationalReport from "./pages/internationalReport/InternationalReport";
import CasinoIframe from "./pages/CasinoIframe";
import TvIframe from "./pages/TvIframe";
import Joker1 from "./pages/casino/Joker1";
import Teenpatti2020C from "./pages/casino/Teenpatti2020C";
import BollywoodCasino2 from "./pages/casino/BollywoodCasino2";
import QueenTopTeenPatti from "./pages/casino/QueenTopTeenPatti";
import AAA2 from "./pages/casino/AAA2";
import AndarBahar150Cards from "./pages/casino/AndarBahar150Cards";
import Cards2Teenpatti from "./pages/casino/Cards2Teenpatti";
import Lottery from "./pages/casino/Lottery";
import AndarBahar50Card from "./pages/casino/AndarBahar50Card";
import OneCardMeter from "./pages/casino/OneCardMeter";
import DTL2020 from "./pages/casino/DTL2020";
import Race220 from "./pages/casino/Raceto2";
import Lucky15 from "./pages/casino/Lucky15";
import JokerOneDay from "./pages/casino/JokerOneDay";
import Joker2020 from "./pages/casino/Joker2020";
import Lucky7C from "./pages/casino/Lucky7C";
import Goal from "./pages/casino/Goal";
import NoteNumber from "./pages/casino/NoteNumber";
import RaceTo17 from "./pages/casino/Race17";
import Race17 from "./pages/casino/Race17";
import TeenMuf from "./pages/casino/TeenMuf";

import DusKaDum from "./pages/casino/DusKaDum";
import Baccarat29 from "./pages/casino/Baccarat29";
// import CMatch20 from "./pages/casino/CMatch20";
// import CricketMatch20 from "./pages/casino/CricketMatch20";

import Kbc from "./pages/casino/Kbc";
import UniqueRoullete from "./pages/casino/UniqueRoullete";
import SicBo from "./pages/casino/SicBo";
import SicBo2 from "./pages/casino/SicBo2";
import SuperOver2 from "./pages/casino/SuperOver2";
import MiniSuperOver from "./pages/casino/MiniSuperOver";
import TeenOne from "./pages/casino/Teen120";
import Teen120 from "./pages/casino/Teen120";
import Teen1 from "./pages/casino/Teen1";
import TeenJoker from "./pages/casino/TeenJoker";
import TeenpattiB2020 from "./pages/casino/TeenPattiB2020";
// import TeenpattiInstant from "./pages/casino/InstantTeenPatti";
import InstantTeenPatti from "./pages/casino/InstantTeenPatti";
import InstantTeenpatti2 from "./pages/casino/InstantTeenPatti2";
import InstantTeenpatti3 from "./pages/casino/InstantTeenPatti3";
import InstantTeenpatti from "./pages/casino/InstantTeenPatti";
import TeenpattiQueenTopOpen from "./pages/casino/TeenPattiQueenTopOpen";
import TeenpattiJackTopOpen from "./pages/casino/TeenPattiJackTopOpen";
// import TeenPatti2 from "./pages/casino/TeenPatti2";

import Teenpatti2 from "./pages/casino/TeenPatti2";
import TeenpattiMuflis from "./pages/casino/TeenPattiMuflis";
import BaccaratCard29 from "./pages/casino/BaccaratCard29";
import Trap from "./pages/casino/Trap";
import Trio from "./pages/casino/Trio";
import InstantWorli from "./pages/casino/InstantWorli";
import Admin from "./pages/Admin";
import ColorPrediction from "./pages/home/ColorPrediction";
import ColorPredictionTransferBalance from "./pages/home/ColorPredictionTransferBalance";
// import Deposit from "./pages/Deposit/Deposit";
// import DepositHistory from "./pages/Deposit/DepositHistory";
// import Transaction from "./pages/Transaction/Transaction";

export default function App() {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.account.userData);
  const isLoading = useSelector((state) => state.account.loading);
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [queryClient] = useState(() => new QueryClient());
  useEffect(() => {
    store.subscribe(() => {
      saveState(store.getState());
    });
  }, [0]);




  return (
    <QueryClientProvider client={queryClient}>
      <Toaster />
      {userData?.token && userData?.resetRequired ? (
        <PrivateOutletM>
          <Routes>
            <Route path="/" element={<ChangePassword />} />
            <Route path="/iframe-casino/:id" element={<CasinoIframe />} />
            <Route path="/iframe-tv/:id" element={<TvIframe />} />
          </Routes>
        </PrivateOutletM>
      ) : userData.token ? (
        <>
          {!window?.location?.pathname.includes("/admin") && <Header />}

          <Routes>
            {" "}
            <Route
              exact
              path="/terms-and-conditions"
              element={<TermsAndCondition />}
            />
            <Route path="/iframe-casino/:id" element={<CasinoIframe />} />
            <Route path="/iframe-tv/:id" element={<TvIframe />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <PrivateOutletM>
            <InitialRule />

            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route exact path="/home" element={<Home />} />
              <Route exact path="/casino-page" element={<CasinoList />} />
              <Route path="/iframe-casino/:id" element={<CasinoIframe />} />
              <Route path="/iframe-tv/:id" element={<TvIframe />} />

              <Route
                exact
                path="/international"
                element={<InternationalCasino />}
              />
              <Route
                exact
                path="/international/:id"
                element={<InternationalCasino />}
              />
              <Route exact path="/casino-page/:id" element={<CasinoList />} />
              <Route exact path="/sports" element={<Home />} />
              <Route
                exact
                path="/all-sports/:sportId"
                element={<SportsPage />}
              />
              <Route
                exact
                path="/responsible-gaming"
                element={<ResponsibleGaming />}
              />
              <Route exact path="/game/soccer/:id" element={<SoccerGame />} />
              <Route
                exact
                path="/game/cricket/:id"
                element={<CricketGame />}
              />
              <Route exact path="/game/tennis/:id" element={<TennisGame />} />
<Route path="/color-prediction" element={<ColorPrediction />} />
<Route path="/color-prediction-transfer" element={<ColorPredictionTransferBalance />} />
              <Route
                path="/reports/accountstatement"
                element={<AccountStatementM />}
              />
              <Route path="/reports/bethistory" element={<BetHistory />} />
              {/* <Route path="/reports/deposit" element={<Deposit />} />
              <Route path="/deposit-history" element={<DepositHistory />} />
              <Route path="/reports/transaction" element={<Transaction />} /> */}
              <Route
                path="/reports/profitloss"
                element={<ProfitLossReport />}
              />
              <Route
                path="/reports/unsetteledbet"
                element={<UnSetteledBet />}
              />
              <Route
                exact
                path="/terms-and-conditions"
                element={<TermsAndCondition />}
              />
              <Route path="/reports/activity-log" element={<ActivityLog />} />
              <Route
                path="/reports/casinoresults"
                element={<CasinoResult />}
              />
              <Route
                path="/reports/internationlreport"
                element={<InternationalReport />}
              />

              <Route
                path="/setting/changebtnvalue"
                element={<ChangeButtonValue />}
              />
              <Route
                path="/settings/security-auth"
                element={<SecurityAuth />}
              />
              <Route
                path="/setting/changepassword"
                element={<ChangePassword />}
              />
              <Route path="/casino/ballbyball" element={<BallByBall />} />
              <Route path="/casino/3cardj" element={<Card3Judgement />} />
              <Route path="/casino/joker1" element={<Joker1 />} />
              <Route path="/casino/teen20c" element={<Teenpatti2020C />} />
              <Route path="/casino/teen3" element={<InstantTeenpatti />} />

              <Route path="/casino/teen32" element={<InstantTeenpatti2 />} />
              <Route path="/casino/teen33" element={<InstantTeenpatti3 />} />
              <Route
                path="/casino/teen41"
                element={<TeenpattiQueenTopOpen />}
              />
              <Route
                path="/casino/teen42"
                element={<TeenpattiJackTopOpen />}
              />
              <Route path="/casino/teen6" element={<Teenpatti2 />} />

              <Route path="/casino/btable2" element={<BollywoodCasino2 />} />
              <Route
                path="/casino/queentopteenpattti"
                element={<QueenTopTeenPatti />}
              />
              <Route path="/casino/aaa2" element={<AAA2 />} />
              <Route path="/casino/race2" element={<Race220 />} />
              <Route path="/casino/lucky15" element={<Lucky15 />} />
              <Route path="/casino/jokeroneday" element={<JokerOneDay />} />
              <Route path="/casino/joker20" element={<Joker2020 />} />
              <Route path="/casino/lucky7eu2" element={<Lucky7C />} />
              <Route path="/casino/kbc" element={<Kbc />} />

              <Route path="/casino/goal" element={<Goal />} />

              <Route path="/casino/ab3" element={<AndarBahar50Card />} />
              <Route path="/casino/cmeter1" element={<OneCardMeter />} />
              <Route path="/casino/dtl20" element={<DTL2020 />} />

              <Route path="/casino/ab4" element={<AndarBahar150Cards />} />
              <Route path="/casino/notenum" element={<NoteNumber />} />
              <Route
                path="/casino/ourroullete"
                element={<UniqueRoullete />}
              />
              <Route path="/casino/race17" element={<Race17 />} />
              <Route path="/casino/teenmuf" element={<TeenMuf />} />
              <Route path="/casino/teensin" element={<Baccarat29 />} />
              <Route path="/casino/dum10" element={<DusKaDum />} />
              <Route path="/casino/patti2" element={<Cards2Teenpatti />} />
              <Route path="/casino/lottcard" element={<Lottery />} />

              <Route path="/casino/superover" element={<SuperOver />} />
              <Route path="/casino/superover2" element={<SuperOver2 />} />
              <Route path="/casino/superover3" element={<MiniSuperOver />} />
              <Route path="/casino/teen120" element={<Teen120 />} />
              <Route path="/casino/teen1" element={<Teen1 />} />

              <Route path="/casino/race20" element={<Race20 />} />
              <Route path="/casino/sicbo" element={<SicBo />} />
              <Route path="/casino/sicbo2" element={<SicBo2 />} />

              <Route path="/casino/teen8" element={<TeenPattiOpen />} />
              <Route path="/casino/teen20" element={<TeenPatti />} />
              <Route path="/casino/worli2" element={<InstantWorli />} />
              <Route path="/casino/worli" element={<WorliMatka />} />

              <Route path="/casino/cricketv3" element={<FiveCricket />} />
              <Route path="/casino/abj" element={<AndarBahar2 />} />
              <Route path="/casino/card32eu" element={<Card32B />} />
              {/* <Route path="/casino/cmatch20" element={<CMatch20 />} /> */}

              <Route path="/casino/ab20" element={<AndarBahar />} />
              <Route path="/casino/btable" element={<BTable />} />
              <Route path="/casino/poker" element={<Poker1Day />} />
              <Route path="/casino/poker20" element={<Poker20 />} />
              <Route path="/casino/teen" element={<TeenpattiOneDay />} />
              <Route path="/casino/dt6" element={<DragonTigerOneDay />} />
              {/* <Route path="/casino/dtl20" element={<DragonTigerLion />} /> */}
              <Route path="/casino/teen9" element={<TeenPattiTest />} />
              <Route path="/casino/teenjoker" element={<TeenJoker />} />
              <Route path="/casino/teen20b" element={<TeenpattiB2020 />} />
              <Route path="/casino/teenmuf" element={<TeenpattiMuflis />} />
              <Route path="/casino/teensin" element={<BaccaratCard29 />} />
              <Route path="/casino/trap" element={<Trap />} />
              <Route path="/casino/trio" element={<Trio />} />

              <Route path="/casino/dt202" element={<DragonTiger2 />} />
              <Route path="/casino/card32" element={<Card32A />} />
              <Route path="/casino/dt20" element={<DragonTiger />} />
              <Route path="/casino/baccarat2" element={<Baccarat2 />} />
              <Route path="/casino/baccarat" element={<Baccarat />} />
              <Route path="/casino/war" element={<CasinoWar />} />
              <Route path="/casino/lucky7eu" element={<Lucky7B />} />
              <Route path="/casino/lucky7" element={<Lucky7A />} />
              <Route path="/casino/poker6" element={<Poker6Player />} />
              <Route path="/casino/queen" element={<CasinoQueen />} />
              <Route path="/casino/cmatch" element={<CricketMatch20 />} />
              {/* <Route path="/admin" element={<Admin />} /> */}
              <Route path="/casino/aaa" element={<AmarAkhbarAnthoany />} />
              <Route path="/casino/cmeter" element={<CasinoMeter />} />
              <Route
                path="/casino/teenpatti/oneday"
                element={<TeenpattiOneDay />}
              />
              {/* REdirect to coming soon */}
              <Route path="/casino-list/*" element={<CasinoComingSoon />} />
              <Route path="/casino/*" element={<CasinoComingSoon />} />
            </Routes>

            {location.pathname.includes("/admin") ? null : <Footer />}
          </PrivateOutletM>
        </>
      ) : (
        <Routes>
          {/* <Route path="/" element={<PublicOutletM />} /> */}
          <Route path="/" element={<PublicOutletM />} />
          {/* <Route path="/" element={<MainLogin />} /> */}
          <Route path="/iframe-casino/:id" element={<CasinoIframe />} />
          <Route path="/iframe-tv/:id" element={<TvIframe />} />

          <Route path="/otp" element={<Otp />} />
          <Route
            exact
            path="/responsible-gaming"
            element={<ResponsibleGaming />}
          />

          <Route
            exact
            path="/terms-and-conditions"
            element={<TermsAndCondition />}
          />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      )}
    </QueryClientProvider>
  );
}
